import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, TextStyles, designTokens } from "@cinch-labs/design-system";
import cx from "classnames";
import Car from "../icons/assets/car.svg";
import SVG from "../svg";
import styles from "./holding-image.module.css";
const { space  } = designTokens.customProperties.ds;
export const HoldingImage = ({ text ="" , isAvailable , className =""  })=>/*#__PURE__*/ _jsxs("div", {
        className: cx(styles.holdingImage, className, {
            [styles.holdingImageUnavailable]: !isAvailable
        }),
        children: [
            /*#__PURE__*/ _jsx(SVG, {
                className: styles.icon,
                children: Car,
                fill: "currentColor",
                size: space["8-x"]
            }),
            text && /*#__PURE__*/ _jsx(Text, {
                type: TextStyles.menuTitle,
                children: text
            })
        ]
    });
